import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-unsubscribe-dialog',
  standalone: true,
  imports: [
    // Angular Material modules you need
    MatDialogModule,
    MatButtonModule,
    TranslateModule
  ],
  templateUrl: './unsubscribe-dialog.component.html',
  styleUrls: ['./unsubscribe-dialog.component.scss']
})
export class UnsubscribeDialogComponent {
  // Variables to store translated strings
  title = '';
  message1 = '';
  message2 = '';
  buttonNo = '';
  buttonYes = '';

 constructor(
  private dialogRef: MatDialogRef<UnsubscribeDialogComponent>,
  private translateService: TranslateService
) {
  this.translateService.get([
    'unsub_confirm_title',
    'unsub_confirm_message_1',
    'unsub_confirm_message_2',
    'unsub_button_no',
    'unsub_button_yes'
  ]).subscribe(translations => {
    this.title = translations['unsub_confirm_title'];
    this.message1 = translations['unsub_confirm_message_1'];
    this.message2 = translations['unsub_confirm_message_2'];
    this.buttonNo = translations['unsub_button_no'];
    this.buttonYes = translations['unsub_button_yes'];
  });
}


  confirm() {
    this.dialogRef.close(true);
  }
}
